<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['grading_system'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-item size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> New Grading System</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(class)="data">
                    {{ data.item.class.name }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="remove(data.item.id, data.item.class.name)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-item"
        centered
        title="New Grading System"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addItem">
          <div class="form-group mb-2">
            <label>Class</label>
            <multiselect
              v-model="schoolclass"
              label="name"
              :options="
                schoolclasses.filter((schoolclass) => schoolclass.level === 2)
              "
            ></multiselect>
            <!-- <div class="row mt-2"><div class="col-2">Tries</div><div class="col-4"><input v-model="triesa" type="text" readonly class="form-control" /></div><div class="col-5"><input v-model="triesb" @input="triesbChange" type="text" class="form-control" /></div></div>
                <div class="row mt-2"><div class="col-2">Good</div><div class="col-4"><input v-model="gooda" type="text" readonly class="form-control" /></div><div class="col-5"><input v-model="goodb" @input="goodbChange" type="text" class="form-control" /></div></div>
                <div class="row mt-2"><div class="col-2">Excellent</div><div class="col-4"><input v-model="excellenta" type="text" readonly class="form-control" /></div><div class="col-5"><input v-model="excellentb" readonly type="text" class="form-control" /></div></div>
              -->
            <div class="row mt-2">
              <div class="col-2"><strong>Tries</strong></div>
              <div class="col-4">
                <input
                  v-model="triesa"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-5">
                <input
                  v-model="triesb"
                  @input="triesbChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-2"><strong>Average</strong></div>
              <div class="col-4">
                <input
                  v-model="averagea"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-5">
                <input
                  v-model="averageb"
                  @input="averagebChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-2"><strong>Good</strong></div>
              <div class="col-4">
                <input
                  v-model="gooda"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-5">
                <input
                  v-model="goodb"
                  @input="goodbChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-2"><strong>Very Good</strong></div>
              <div class="col-4">
                <input
                  v-model="vgooda"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-5">
                <input
                  v-model="vgoodb"
                  @input="vgoodbChange"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-2"><strong>Excellent</strong></div>
              <div class="col-4">
                <input
                  v-model="excellenta"
                  type="text"
                  readonly
                  class="form-control"
                />
              </div>
              <div class="col-5">
                <input
                  v-model="excellentb"
                  readonly
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-item')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-item"
        centered
        title="Delete Grading System"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeItem">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Subject : <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-item')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  gradesComputed,
  gradesMethods,
  schoolclassComputed,
  schoolclassMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Nursery Grading System",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Nursery Grading System",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Nursery Grading System", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "class", label: "Class", visible: true },
        { key: "excellent", label: "Excellent", visible: true },
        { key: "vgood", label: "Very Good", visible: true },
        { key: "good", label: "Good", visible: true },
        { key: "average", label: "Average", visible: true },
        { key: "tries", label: "Needs Improvement", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "",
      excellenta: "",
      excellentb: 100,
      vgooda: "",
      vgoodb: "",
      gooda: "",
      goodb: "",
      averagea: "",
      averageb: "",
      triesa: 0,
      triesb: "",
      schoolclass: "",
    };
  },
  computed: {
    ...gradesComputed,
    ...schoolclassComputed,
    List() {
      return this.grades.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.grades.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.grades.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchGrades();
    this.fetchSchoolClasses();
    this.TotalRows = this.gradess.length;
    this.isBusy = false;
  },
  methods: {
    ...gradesMethods,
    ...schoolclassMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-item");
    },
    async addItem() {
      let formData = new FormData();
      formData.append("class", this.schoolclass.id);
      formData.append("excellent", this.excellenta + " - " + this.excellentb);
      formData.append("vgood", this.vgooda + " - " + this.vgoodb);
      formData.append("good", this.gooda + " - " + this.goodb);
      formData.append("average", this.averagea + " - " + this.averageb);
      formData.append("tries", this.triesa + " - " + this.triesb);
      let url = "/addgradingsytem";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchGrades();
          this.$bvModal.hide("new-item");
          this.class = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeItem() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removegradingsytem";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchGrades();
          this.$bvModal.hide("delete-item");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },

    vgoodbChange() {
      this.excellenta = Number(this.vgoodb) + 1;
    },
    goodbChange() {
      this.vgooda = Number(this.goodb) + 1;
    },
    averagebChange() {
      this.gooda = Number(this.averageb) + 1;
    },
    triesbChange() {
      this.averagea = Number(this.triesb) + 1;
    },
  },
};
</script>
